import { render, staticRenderFns } from "./JohnAustin.vue?vue&type=template&id=2f51df33&scoped=true&lang=html&"
import script from "./JohnAustin.vue?vue&type=script&lang=js&"
export * from "./JohnAustin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f51df33",
  null
  
)

export default component.exports